_N_E =
(window["webpackJsonp_N_E"] = window["webpackJsonp_N_E"] || []).push([[106],{

/***/ "LaX8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FacebookAndTwitterSeoHeaderMeta; });
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("1t7P");
/* harmony import */ var core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("jQ/y");
/* harmony import */ var core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_description__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("2G9S");
/* harmony import */ var core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_concat__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("jwue");
/* harmony import */ var core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_for_each__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("z84I");
/* harmony import */ var core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_map__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("ho0z");
/* harmony import */ var core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_function_name__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("+oxZ");
/* harmony import */ var core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("fGyu");
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("vpUC");
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var _clubmed_utils__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__("n4CU");
/* harmony import */ var _clubmed_utils__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(_clubmed_utils__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var _utils_media_server__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__("FLQK");
/* harmony import */ var _utils_responsive_ResponsiveContext__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__("1JJ2");
/* harmony import */ var _cms_toolkit_constants__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__("psNz");








var __jsx = react__WEBPACK_IMPORTED_MODULE_9___default.a.createElement;






var PAGE_TYPES = _clubmed_utils__WEBPACK_IMPORTED_MODULE_10__["b2cPagesService"].PAGE_TYPES;
var FacebookAndTwitterSeoHeaderMeta = function FacebookAndTwitterSeoHeaderMeta(_ref) {
  var description = _ref.description,
      _ref$immersiveUrl = _ref.immersiveUrl,
      immersiveUrl = _ref$immersiveUrl === void 0 ? '' : _ref$immersiveUrl,
      lines = _ref.lines,
      _ref$pageType = _ref.pageType,
      pageType = _ref$pageType === void 0 ? '' : _ref$pageType,
      title = _ref.title,
      url = _ref.url;

  var _useResponsive = Object(_utils_responsive_ResponsiveContext__WEBPACK_IMPORTED_MODULE_12__[/* useResponsive */ "b"])(),
      isDesktop = _useResponsive.isDesktop;
  /**
   * Format immersive url for SEO
   * @param {string} urlImmersive The url to format
   * @returns The url formatted
   */


  var getImmersiveUrl = function getImmersiveUrl(urlImmersive) {
    return Object(_utils_media_server__WEBPACK_IMPORTED_MODULE_11__[/* getUrl */ "a"])({
      url: urlImmersive,
      width: 1200,
      height: 'auto',
      format: '_AUTOFORMAT_',
      quality: 70,
      transform: 'resize'
    });
  };

  var getFirstImmersiveUrl = function getFirstImmersiveUrl(allLines) {
    var immersives = [];

    var collectFn = function collectFn(line) {
      var _line$props$media;

      var backgroundURL = isDesktop ? line.props.backgroundURLDesktop : line.props.backgroundURLMobile;
      immersives = line.name === _cms_toolkit_constants__WEBPACK_IMPORTED_MODULE_13__[/* IMMERSIVE */ "s"] ? [].concat(Object(_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_7__[/* default */ "a"])(immersives), [getImmersiveUrl(backgroundURL)]) : immersives;
      immersives = line.name === _cms_toolkit_constants__WEBPACK_IMPORTED_MODULE_13__[/* PRODUCT_IMMERSIVE */ "N"] && !!((_line$props$media = line.props.media) === null || _line$props$media === void 0 ? void 0 : _line$props$media.photos) ? [].concat(Object(_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_7__[/* default */ "a"])(immersives), Object(_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_7__[/* default */ "a"])(line.props.media.photos.map(function (p) {
        return getImmersiveUrl(p.url);
      }))) : immersives;
      (line.props.lines || []).forEach(collectFn);
    };

    allLines.forEach(collectFn);
    return immersives && immersives.length > 0 ? immersives[0] : '';
  };

  var immersiveUrlFromLines = lines && lines.length > 0 ? getFirstImmersiveUrl(lines) : '';
  return __jsx(next_head__WEBPACK_IMPORTED_MODULE_8___default.a, null, __jsx("meta", {
    property: "og:type",
    content: "website"
  }), pageType !== PAGE_TYPES.CRUISE && pageType !== PAGE_TYPES.RESORT && pageType !== PAGE_TYPES.RESORT_MICE && __jsx("meta", {
    property: "og:title",
    content: title
  }), pageType !== PAGE_TYPES.CRUISE && __jsx("meta", {
    property: "og:description",
    content: description
  }), __jsx("meta", {
    property: "og:image",
    content: immersiveUrl || immersiveUrlFromLines
  }), __jsx("meta", {
    property: "og:url",
    content: url
  }), __jsx("meta", {
    name: "twitter:card",
    content: "summary_large_image"
  }), pageType !== PAGE_TYPES.CRUISE && pageType !== PAGE_TYPES.RESORT && pageType !== PAGE_TYPES.RESORT_MICE && __jsx("meta", {
    name: "twitter:title",
    content: title
  }), pageType !== PAGE_TYPES.CRUISE && __jsx("meta", {
    name: "twitter:description",
    content: description
  }), __jsx("meta", {
    name: "twitter:image",
    content: immersiveUrl || immersiveUrlFromLines
  }), __jsx("meta", {
    name: "twitter:url",
    content: url
  }));
};

/***/ }),

/***/ "RNiq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, "__N_SSP", function() { return /* binding */ __N_SSP; });

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.symbol.js
var es_symbol = __webpack_require__("1t7P");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.symbol.description.js
var es_symbol_description = __webpack_require__("jQ/y");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.filter.js
var es_array_filter = __webpack_require__("LW0h");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.for-each.js
var es_array_for_each = __webpack_require__("jwue");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.map.js
var es_array_map = __webpack_require__("z84I");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.get-own-property-descriptor.js
var es_object_get_own_property_descriptor = __webpack_require__("daRM");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.get-own-property-descriptors.js
var es_object_get_own_property_descriptors = __webpack_require__("FtHn");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.keys.js
var es_object_keys = __webpack_require__("+KXO");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.to-string.js
var es_object_to_string = __webpack_require__("7x/C");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.promise.js
var es_promise = __webpack_require__("JtPf");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/web.dom-collections.for-each.js
var web_dom_collections_for_each = __webpack_require__("+oxZ");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__("cxan");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("zjfJ");

// EXTERNAL MODULE: /opt/webapp/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: /opt/webapp/node_modules/next/dynamic.js
var dynamic = __webpack_require__("hNT8");
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);

// EXTERNAL MODULE: /opt/webapp/node_modules/next/head.js
var head = __webpack_require__("vpUC");
var head_default = /*#__PURE__*/__webpack_require__.n(head);

// EXTERNAL MODULE: /opt/webapp/node_modules/next/router.js
var router = __webpack_require__("Bkb1");

// EXTERNAL MODULE: ../utils/dist/index.js
var dist = __webpack_require__("n4CU");

// EXTERNAL MODULE: ./src/routes/constants.js
var constants = __webpack_require__("dNxv");

// EXTERNAL MODULE: ./src/client/tracking/constants.js
var tracking_constants = __webpack_require__("829J");

// EXTERNAL MODULE: ./src/client/context/PageContext.js
var PageContext = __webpack_require__("EkOT");

// EXTERNAL MODULE: ./src/client/context/ReactAppContext.js
var ReactAppContext = __webpack_require__("Ub5k");

// EXTERNAL MODULE: ./src/client/components/seo/FacebookAndTwitterSeoHeaderMeta.jsx
var FacebookAndTwitterSeoHeaderMeta = __webpack_require__("LaX8");

// EXTERNAL MODULE: ./src/client/components/third-party/BaiduSeoScript.jsx + 2 modules
var BaiduSeoScript = __webpack_require__("XL2j");

// EXTERNAL MODULE: ./src/utils/uri/uriUtils.js
var uriUtils = __webpack_require__("nv//");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.regexp.exec.js
var es_regexp_exec = __webpack_require__("KqXw");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.string.split.js
var es_string_split = __webpack_require__("Ysgh");

// CONCATENATED MODULE: ./src/client/views/home/HomeView.helper.js












function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      Object(defineProperty["a" /* default */])(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}


var HomeView_helper_formatContacts = function formatContacts(contacts, locale) {
  return contacts.map(function (contact) {
    var contactOption = [];

    if (contact.hearingImpairedSupported) {
      contactOption.push('HearingImpairedSupported');
    }

    if (contact.tollFree) {
      contactOption.push('TollFree');
    }

    return _objectSpread({
      '@type': 'ContactPoint',
      telephone: contact.phoneNumber,
      contactType: dist["constants"].CONTACT_TYPES[contact.type],
      areaServed: locale.split('-')[1]
    }, contactOption.length === 0 ? null : {
      contactOption: contactOption
    });
  });
};
// CONCATENATED MODULE: ./src/client/views/home/HomeView.jsx













var __jsx = react_default.a.createElement;

function HomeView_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function HomeView_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { HomeView_ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { HomeView_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }














var Line = dynamic_default()(function () {
  return __webpack_require__.e(/* import() */ 28).then(__webpack_require__.bind(null, "ybtA")).then(function (m) {
    return m.Line;
  });
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/("ybtA")];
    },
    modules: ["../../components/frameworks/line/Line"]
  }
});
var JsonLDScript = /*#__PURE__*/Object(react["memo"])(function (_ref) {
  var url = _ref.url,
      description = _ref.description,
      contacts = _ref.contacts,
      locale = _ref.locale;
  var contactPoint = HomeView_helper_formatContacts(contacts, locale);
  return __jsx("script", {
    type: "application/ld+json" // eslint-disable-next-line react/no-danger
    ,
    dangerouslySetInnerHTML: {
      __html: JSON.stringify(HomeView_objectSpread({
        '@context': 'https://schema.org',
        '@type': 'Organization',
        url: url,
        name: dist["constants"].WEBSITE_NAME,
        description: description
      }, contactPoint.length > 0 && {
        contactPoint: contactPoint
      }))
    }
  });
});
var HomeView_HomeView = function HomeView(_ref2) {
  var config = _ref2.config,
      page = _ref2.page;

  var _useRouter = Object(router["useRouter"])(),
      asPath = _useRouter.asPath;

  var _useAppContext = Object(ReactAppContext["c" /* useAppContext */])(),
      locale = _useAppContext.locale,
      originalUrl = _useAppContext.originalUrl,
      userAgent = _useAppContext.userAgent;

  var _usePageContext = Object(PageContext["b" /* usePageContext */])(),
      pageTitle = _usePageContext.pageTitle,
      pageType = _usePageContext.pageType,
      pageDescription = _usePageContext.pageDescription;

  var origin = Object(uriUtils["c" /* convertUrlToOrigin */])(originalUrl);
  var currentUri = origin + asPath;
  var _config$seo = config.seo;
  _config$seo = _config$seo === void 0 ? {} : _config$seo;
  var _config$seo$contacts = _config$seo.contacts,
      contacts = _config$seo$contacts === void 0 ? [] : _config$seo$contacts,
      description = config.footer.seo.description;

  if (!page) {
    return null;
  }

  return __jsx(react["Fragment"], null, __jsx(head_default.a, null, __jsx(JsonLDScript, {
    url: originalUrl,
    description: description,
    contacts: contacts,
    locale: locale
  }), __jsx(BaiduSeoScript["a" /* BaiduSeoScript */], {
    lines: page.lines,
    locale: locale,
    userAgent: userAgent,
    originalUrl: originalUrl,
    pageTitle: pageTitle,
    pageType: pageType,
    pageDescription: pageDescription
  })), __jsx(FacebookAndTwitterSeoHeaderMeta["a" /* FacebookAndTwitterSeoHeaderMeta */], {
    description: pageDescription,
    lines: page.lines,
    title: pageTitle,
    url: currentUri
  }), __jsx(Line, page.tracking), page.lines.map(function (line) {
    return __jsx(Line, Object(esm_extends["a" /* default */])({}, line, {
      key: line.id
    }));
  }));
};
HomeView_HomeView.pageId = constants["h" /* HOME */];
HomeView_HomeView.pageType = tracking_constants["x" /* STATIC_PAGE_TYPES */].SHOPPING_HOME;
// CONCATENATED MODULE: ./pages/index.js

var __N_SSP = true;
/* harmony default export */ var pages = __webpack_exports__["default"] = (HomeView_HomeView);

/***/ }),

/***/ "XL2j":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ BaiduSeoScript_BaiduSeoScript; });

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.concat.js
var es_array_concat = __webpack_require__("2G9S");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.for-each.js
var es_array_for_each = __webpack_require__("jwue");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.map.js
var es_array_map = __webpack_require__("z84I");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.function.name.js
var es_function_name = __webpack_require__("ho0z");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/web.dom-collections.for-each.js
var web_dom_collections_for_each = __webpack_require__("+oxZ");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js + 2 modules
var toConsumableArray = __webpack_require__("fGyu");

// EXTERNAL MODULE: /opt/webapp/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./src/client/components/utils/responsive/ResponsiveContext.js
var ResponsiveContext = __webpack_require__("1JJ2");

// EXTERNAL MODULE: ./node_modules/moment/moment.js
var moment = __webpack_require__("wd/R");
var moment_default = /*#__PURE__*/__webpack_require__.n(moment);

// EXTERNAL MODULE: ./src/client/components/utils/media-server/index.js
var media_server = __webpack_require__("FLQK");

// CONCATENATED MODULE: ./src/seo/json-ld/index.js



function getBaiduStructuredPageData(title, description, imageUrls, pageUrl) {
  return {
    '@context': 'https://zhanzhang.baidu.com/contexts/cambrian.jsonld',
    '@id': pageUrl,
    title: title,
    description: description,
    images: imageUrls.map(function (url) {
      return media_server["a" /* getUrl */]({
        format: '_AUTOFORMAT_',
        url: url,
        width: 2000,
        height: 'auto',
        transform: 'resize',
        quality: 70
      });
    }),
    pubDate: moment_default()() // Set to the beginning of the current quarter,
    // 1st day of months, 12:00 am
    .startOf('quarter').format('YYYY-MM-DDThh:mm:ss')
  };
}
// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.symbol.js
var es_symbol = __webpack_require__("1t7P");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.filter.js
var es_array_filter = __webpack_require__("LW0h");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.join.js
var es_array_join = __webpack_require__("7xRU");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.get-own-property-descriptor.js
var es_object_get_own_property_descriptor = __webpack_require__("daRM");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.get-own-property-descriptors.js
var es_object_get_own_property_descriptors = __webpack_require__("FtHn");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.keys.js
var es_object_keys = __webpack_require__("+KXO");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.to-string.js
var es_object_to_string = __webpack_require__("7x/C");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.regexp.constructor.js
var es_regexp_constructor = __webpack_require__("iKE+");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.regexp.exec.js
var es_regexp_exec = __webpack_require__("KqXw");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.regexp.to-string.js
var es_regexp_to_string = __webpack_require__("DZ+c");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("zjfJ");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__("QsI/");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__("VtSi");
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);

// EXTERNAL MODULE: /opt/webapp/node_modules/urijs/src/URI.js
var URI = __webpack_require__("z/9Z");
var URI_default = /*#__PURE__*/__webpack_require__.n(URI);

// EXTERNAL MODULE: ../domains-service/dist/index.js
var dist = __webpack_require__("g/E1");
var dist_default = /*#__PURE__*/__webpack_require__.n(dist);

// EXTERNAL MODULE: ./logger/index.js
var logger = __webpack_require__("m0zD");
var logger_default = /*#__PURE__*/__webpack_require__.n(logger);

// EXTERNAL MODULE: ./src/utils/request/requestDictionary.js
var requestDictionary = __webpack_require__("CcNa");

// EXTERNAL MODULE: ./src/utils/graphql-client/graphqlClient.js
var graphqlClient = __webpack_require__("PIvV");

// CONCATENATED MODULE: ./src/seo/sitemap/sitemap.utils.js


















function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      Object(defineProperty["a" /* default */])(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}






var SITEMAP_URL_CHANGE_FREQUENCY = 'weekly';
var SITEMAP_URL_PRIORITY = 0.5;
var XML_NAMESPACES = ['xmlns="https://www.sitemaps.org/schemas/sitemap/0.9"', 'xmlns:xhtml="https://www.w3.org/1999/xhtml"'];
function isBaiduBot() {
  var userAgent = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : ''; // Detects Baidu’s web crawler via the user agent string.
  // e.g. "Mozilla/5.0 (compatible; Baiduspider/2.0; +http://www.baidu.com/search/spider.html)"

  return new RegExp('Baiduspider', 'ig').test(userAgent);
}
function getXmlNamespaces(userAgent) {
  var xmlNamespaces = isBaiduBot(userAgent) ? [].concat(XML_NAMESPACES, ['xmlns:mobile="https://www.baidu.com/schemas/sitemap-mobile/1/"']) : XML_NAMESPACES;
  return xmlNamespaces.join(' ');
}
function getPageUrls(_x, _x2) {
  return _getPageUrls.apply(this, arguments);
}

function _getPageUrls() {
  _getPageUrls = Object(asyncToGenerator["a" /* default */])( /*#__PURE__*/regenerator_default.a.mark(function _callee(pageTypes, appContext) {
    var pageTypesString, pagesQuery, _yield$graphQLClient$, pages;

    return regenerator_default.a.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            pageTypesString = pageTypes.map(function (pageType) {
              return "\"".concat(pageType, "\"");
            }).join(',');
            pagesQuery = "{\n    pages: pagesByTypes(pageTypes: [".concat(pageTypesString, "]) {\n      href: url\n    }\n  }");
            _context.prev = 2;
            _context.next = 5;
            return graphqlClient["a" /* default */].runQuery(pagesQuery, appContext, {
              requestName: requestDictionary["Ic" /* PAGE_SITEMAP */]
            });

          case 5:
            _yield$graphQLClient$ = _context.sent;
            pages = _yield$graphQLClient$.pages;
            return _context.abrupt("return", pages);

          case 10:
            _context.prev = 10;
            _context.t0 = _context["catch"](2);
            logger_default.a.error(_context.t0);
            return _context.abrupt("return", []);

          case 14:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[2, 10]]);
  }));
  return _getPageUrls.apply(this, arguments);
}

function getPageEntries(dataEntries, _ref) {
  var locale = _ref.locale,
      originalUrl = _ref.originalUrl,
      userAgent = _ref.userAgent;
  var uri = new URI_default.a(originalUrl);
  var hostname = uri.hostname();
  var tld = uri.tld();
  var isDomainDefaultLocale = dist_default.a.getLocaleFromHostname(tld) === locale;
  return dataEntries.map(function (_ref2) {
    var href = _ref2.href; // Build full entry url

    var entryUri = new URI_default.a(href).protocol('https').hostname(hostname).tld(tld);

    if (!isDomainDefaultLocale && locale) {
      entryUri.addQuery({
        locale: locale
      });
    } // Build complete entry


    return _objectSpread({
      url: entryUri.toString(),
      changefreq: SITEMAP_URL_CHANGE_FREQUENCY,
      priority: SITEMAP_URL_PRIORITY
    }, isBaiduBot(userAgent) && {
      mobile: 'pc mobile'
    });
  });
}
function getHreflangs(_x3) {
  return _getHreflangs.apply(this, arguments);
}

function _getHreflangs() {
  _getHreflangs = Object(asyncToGenerator["a" /* default */])( /*#__PURE__*/regenerator_default.a.mark(function _callee2(appContext) {
    var query, _yield$graphQLClient$2, hreflangs;

    return regenerator_default.a.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            query = "{\n  hreflangs {\n    url\n    links {\n      url\n      lang\n    }\n  }\n}";
            _context2.prev = 1;
            _context2.next = 4;
            return graphqlClient["a" /* default */].runQuery(query, appContext, {
              requestName: Object(requestDictionary["Id" /* getGqlName */])(['CMS', 'HREFLANGS'])
            });

          case 4:
            _yield$graphQLClient$2 = _context2.sent;
            hreflangs = _yield$graphQLClient$2.hreflangs;
            return _context2.abrupt("return", hreflangs);

          case 9:
            _context2.prev = 9;
            _context2.t0 = _context2["catch"](1);
            logger_default.a.error(_context2.t0);
            return _context2.abrupt("return", []);

          case 13:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, null, [[1, 9]]);
  }));
  return _getHreflangs.apply(this, arguments);
}
// EXTERNAL MODULE: ./src/utils/locale/localeUtils.js
var localeUtils = __webpack_require__("1tzK");

// CONCATENATED MODULE: ./src/client/components/third-party/BaiduSeoScript.jsx






var __jsx = react_default.a.createElement;





var BaiduSeoScript_BaiduSeoScript = function BaiduSeoScript(_ref) {
  var lines = _ref.lines,
      locale = _ref.locale,
      userAgent = _ref.userAgent,
      originalUrl = _ref.originalUrl,
      pageTitle = _ref.pageTitle,
      pageDescription = _ref.pageDescription;

  var _useResponsive = Object(ResponsiveContext["b" /* useResponsive */])(),
      isDesktop = _useResponsive.isDesktop;

  var getImmersives = function getImmersives(allLines) {
    var immersives = [];

    var collectFn = function collectFn(line) {
      var _line$props$media;

      var backgroundURL = isDesktop ? line.props.backgroundURLDesktop : line.props.backgroundURLMobile;
      immersives = line.name === 'immersive' ? [].concat(Object(toConsumableArray["a" /* default */])(immersives), [backgroundURL]) : immersives;
      immersives = line.name === 'product-immersive' && !!((_line$props$media = line.props.media) === null || _line$props$media === void 0 ? void 0 : _line$props$media.photos) ? [].concat(Object(toConsumableArray["a" /* default */])(immersives), Object(toConsumableArray["a" /* default */])(line.props.media.photos.map(function (p) {
        return p.url;
      }))) : immersives;
      (line.props.lines || []).forEach(collectFn);
    };

    allLines.forEach(collectFn);
    return immersives;
  };

  return isBaiduBot(userAgent) && Object(localeUtils["a" /* isChineseLocale */])(locale) && __jsx("script", {
    type: "application/ld+json",
    dangerouslySetInnerHTML: {
      __html: JSON.stringify(getBaiduStructuredPageData(pageTitle, pageDescription, getImmersives(lines), originalUrl))
    }
  });
};

/***/ }),

/***/ "cbTx":
/***/ (function(module, exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/",
      function () {
        return __webpack_require__("RNiq");
      }
    ]);
  

/***/ }),

/***/ "psNz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ALL_INCLUSIVE_PUSH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return BRAND_PROMISE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return BRAND_SUPERIORITY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return BUTTON_TICKET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return CHECKLIST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return COMPARISON_TABLE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return CRISIS_ALERT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return CRUISE_BOOKING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return CRUISE_PROGRAM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return DESTINATIONS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return DOWNLOAD_LINKS_LIST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return EDITORIAL_FOLDING_BLOCK; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return EVENT_ANIMATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return EVENT_FORM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return EXCLUSIVE_COLLECTION_SPACE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return EXCLUSIVE_COLLECTION_SPACE_INTRODUCTION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return HAPPY_TO_CARE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return HIGHLIGHT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return IMMERSIVE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return INSPIRATIONAL_GRID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return LAST_SEEN_PRODUCTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return MEDIA_TEXT_HORIZONTAL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return MEDIA_TEXT_VERTICAL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return MEDIA_THUMBNAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return MUST_TRY_EXPERIENCES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return NAVIGATION_TAB; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return NAVIGATION_TABS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "D", function() { return OFFER_DESCRIPTION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "E", function() { return OFFER_LEGAL_INFORMATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "F", function() { return OFFER_SEO; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return OFFERS_GRID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "C", function() { return OFFERS_PUSH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "G", function() { return PAGE_TRACKING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "H", function() { return PREBOOKING_FORM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "J", function() { return PRODUCT_ACTIVITIES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "K", function() { return PRODUCT_BREADCRUMB; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "L", function() { return PRODUCT_CHILDCARES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "M", function() { return PRODUCT_IMAGE_MAP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N", function() { return PRODUCT_IMMERSIVE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "O", function() { return PRODUCT_INFORMATION_SUMMARY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Q", function() { return PRODUCT_SERVICES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "R", function() { return PRODUCT_SIGNATURES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "S", function() { return PRODUCT_STREET_VIEW; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "T", function() { return PRODUCT_STRENGTHS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "I", function() { return PRODUCTS_FILTERS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "P", function() { return PRODUCT_PRICE_TICKET_CUSTOM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "U", function() { return PRODUCT_TAGS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "V", function() { return QRCODE_PRODUCT_DRESSCODE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "W", function() { return QRCODE_PRODUCT_PROGRAM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "X", function() { return QUOTATION_FORM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Y", function() { return RELATED_PRODUCTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Z", function() { return RESORT_ACCESS_AND_MAP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ab", function() { return RESORT_ACCOMMODATION_EXCLUSIVE_COLLECTION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "bb", function() { return RESORT_ACCOMMODATION_TYPES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "cb", function() { return RESORT_BARS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "db", function() { return RESORT_BOOKING_BE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "eb", function() { return RESORT_DESTINATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fb", function() { return RESORT_DISTRICT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "gb", function() { return RESORT_FLASH_INFO; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "hb", function() { return RESORT_GRID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ib", function() { return RESORT_INTRODUCTION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "jb", function() { return RESORT_MEETING_ROOM_INFO; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "kb", function() { return RESORT_MULTIMEDIA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "lb", function() { return RESORT_PRICE_REMOTE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "mb", function() { return RESORT_PRICE_TICKET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "nb", function() { return RESORT_RECOMMENDATIONS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ob", function() { return RESORT_RESTAURANTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "pb", function() { return RESORT_SEO; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "qb", function() { return RESORT_SUMMARY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "rb", function() { return RESORT_TAGS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "sb", function() { return RESORT_TRIPADVISOR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "tb", function() { return SECTION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ub", function() { return SECTIONS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "vb", function() { return SMART_FAQ; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "wb", function() { return SUBMISSION_STATUS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "xb", function() { return TAB; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "yb", function() { return TABS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "zb", function() { return TEASER_CARDS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Ab", function() { return TEST_AB; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Bb", function() { return TEXT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Cb", function() { return THEMATIC; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Db", function() { return TITLE_AND_TEXT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Hb", function() { return TRAVEL_RESTRICTIONS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Eb", function() { return TOUR_INTRODUCTION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Fb", function() { return TOUR_PRACTICAL_INFORMATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Gb", function() { return TOUR_PROGRAM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Ib", function() { return TRIPADVISOR_TESTIMONY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Jb", function() { return VIDEO; });
var ALL_INCLUSIVE_PUSH = 'all-inclusive-push';
var BRAND_PROMISE = 'brand-promise';
var BRAND_SUPERIORITY = 'brand-superiority';
var BUTTON_TICKET = 'button-ticket';
var CHECKLIST = 'checklist';
var COMPARISON_TABLE = 'comparison-table';
var CRISIS_ALERT = 'crisis-alert';
var CRUISE_BOOKING = 'cruise-booking';
var CRUISE_PROGRAM = 'cruise-program';
var DESTINATIONS = 'destinations';
var DOWNLOAD_LINKS_LIST = 'download-links-list';
var EDITORIAL_FOLDING_BLOCK = 'editorial-folding-block';
var EVENT_ANIMATION = 'event-animation';
var EVENT_FORM = 'event-form';
var EXCLUSIVE_COLLECTION_SPACE = 'exclusive-collection-space';
var EXCLUSIVE_COLLECTION_SPACE_INTRODUCTION = 'exclusive-collection-space-introduction';
var HAPPY_TO_CARE = 'happy-to-care';
var HIGHLIGHT = 'highlight';
var IMMERSIVE = 'immersive';
var INSPIRATIONAL_GRID = 'inspirational-grid';
var LAST_SEEN_PRODUCTS = 'last-seen-products';
var MEDIA_TEXT_HORIZONTAL = 'media-text-horizontal';
var MEDIA_TEXT_VERTICAL = 'media-text-vertical';
var MEDIA_THUMBNAIL = 'media-thumbnail';
var MUST_TRY_EXPERIENCES = 'must-try-experiences';
var NAVIGATION_TAB = 'navigation-tab';
var NAVIGATION_TABS = 'navigation-tabs';
var OFFER_DESCRIPTION = 'offer-description';
var OFFER_LEGAL_INFORMATION = 'offer-legal-information';
var OFFER_SEO = 'offer-seo';
var OFFERS_GRID = 'offers-grid';
var OFFERS_PUSH = 'offers-push';
var PAGE_TRACKING = 'page-tracking';
var PREBOOKING_FORM = 'prebooking-form';
var PRODUCT_ACTIVITIES = 'product-activities';
var PRODUCT_BREADCRUMB = 'product-breadcrumb';
var PRODUCT_CHILDCARES = 'product-childcares';
var PRODUCT_IMAGE_MAP = 'product-image-map';
var PRODUCT_IMMERSIVE = 'product-immersive';
var PRODUCT_INFORMATION_SUMMARY = 'product-information-summary';
var PRODUCT_SERVICES = 'product-services';
var PRODUCT_SIGNATURES = 'product-signatures';
var PRODUCT_STREET_VIEW = 'product-street-view';
var PRODUCT_STRENGTHS = 'product-strengths';
var PRODUCTS_FILTERS = 'products-filters';
var PRODUCT_PRICE_TICKET_CUSTOM = 'product-price-ticket-custom';
var PRODUCT_TAGS = 'product-tags';
var QRCODE_PRODUCT_DRESSCODE = 'qrcode-product-dresscode';
var QRCODE_PRODUCT_PROGRAM = 'qrcode-product-program';
var QUOTATION_FORM = 'quotation-form';
var RELATED_PRODUCTS = 'related-products';
var RESORT_ACCESS_AND_MAP = 'resort-access-and-map';
var RESORT_ACCOMMODATION_EXCLUSIVE_COLLECTION = 'resort-accommodation-exclusivecollection';
var RESORT_ACCOMMODATION_TYPES = 'resort-accommodationTypes';
var RESORT_BARS = 'resort-bars';
var RESORT_BOOKING_BE = 'resort-bookingBE';
var RESORT_DESTINATION = 'resort-destination';
var RESORT_DISTRICT = 'resort-district';
var RESORT_FLASH_INFO = 'resort-flash-info';
var RESORT_GRID = 'resort-grid';
var RESORT_INTRODUCTION = 'resort-introduction';
var RESORT_MEETING_ROOM_INFO = 'resort-meeting-room-info';
var RESORT_MULTIMEDIA = 'resort-multimedia';
var RESORT_PRICE_REMOTE = 'resort-price-remote';
var RESORT_PRICE_TICKET = 'resort-price-ticket';
var RESORT_RECOMMENDATIONS = 'resort-recommendations';
var RESORT_RESTAURANTS = 'resort-restaurants';
var RESORT_SEO = 'resort-seo';
var RESORT_SUMMARY = 'resort-summary';
var RESORT_TAGS = 'product-tags';
var RESORT_TRIPADVISOR = 'resort-tripadvisor';
var SECTION = 'section';
var SECTIONS = 'sections';
var SMART_FAQ = 'smart-faq';
var SUBMISSION_STATUS = 'submission-status';
var TAB = 'tab';
var TABS = 'tabs';
var TEASER_CARDS = 'teaser-cards';
var TEST_AB = 'test-ab';
var TEXT = 'text';
var THEMATIC = 'thematic';
var TITLE_AND_TEXT = 'title-and-text';
var TRAVEL_RESTRICTIONS = 'travel-restrictions';
var TOUR_INTRODUCTION = 'tour-introduction';
var TOUR_PRACTICAL_INFORMATION = 'tour-practical-information';
var TOUR_PROGRAM = 'tour-program';
var TRIPADVISOR_TESTIMONY = 'tripadvisor-testimony';
var VIDEO = 'video';

/***/ })

},[["cbTx",3,1,5,0,6,7,4,9,8,11,12,13,26]]]);